import React from 'react';
import "./RealWeding.css";
import wedding1 from '../images/png/image 59.png';
import wedding2 from '../images/png/image 59 (1).png';
import wedding3 from '../images/png/image 59 (2).png';
import wedding4 from '../images/png/image 59 (3).png';


import subwedding1 from '../images/png/image 56.png';
import subwedding2 from '../images/png/image 57.png';


const RealWeding=()=>{
  return (
    <div>
        <div className='realwedding'>
            <div className='wedding'>
                <h1>Real Wedding</h1>
                <p>List your wedding and browse portfolio</p>
            </div>
            <div className='weddingcard'>
                <div className='wedcard1'>
                    <div className='wcardimg'>
                        <img src={wedding1} alt="err"/>
                    </div>
                    <div className='wedsubcard1'>
                        <img src={subwedding1} alt="err"/>
                        <img src={subwedding2} alt="err"/>
                        <img src={subwedding2} alt="err"/>
                    </div>
                    <div className='wedContent'>
                        <h3>Danielle & Ronnie</h3>
                        <p>38 photos,hittery,Polland</p> 
                    </div>
                    
                </div>
                <div className='wedcard2'>
                    <div className='wcardimg'>
                        <img src={wedding2} alt="err"/>
                    </div>
                    <div className='wedsubcard1'>
                        <img src={subwedding1} alt="err"/>
                        <img src={subwedding2} alt="err"/>
                        <img src={subwedding2} alt="err"/>
                    </div>
                    <div className='wedContent'>
                        <h3>Danielle & Ronnie</h3>
                        <p>38 photos,hittery,Polland</p> 
                    </div>
                    
                </div>
                <div className='wedcard3'>
                    <div className='wcardimg'>
                        <img src={wedding3} alt="err"/>
                    </div>
                    <div className='wedsubcard1'>
                        <img src={subwedding1} alt="err"/>
                        <img src={subwedding2} alt="err"/>
                        <img src={subwedding2} alt="err"/>
                    </div>
                    <div className='wedContent'>
                        <h3>Danielle & Ronnie</h3>
                        <p>38 photos,hittery,Polland</p> 
                    </div>
                    
                </div>
                <div className='wedcard4'>
                    <div className='wcardimg'>
                        <img src={wedding4} alt="err"/>
                    </div>
                    <div className='wedsubcard1'>
                        <img src={subwedding1} alt="err"/>
                        <img src={subwedding2} alt="err"/>
                        <img src={subwedding2} alt="err"/>
                    </div>
                    <div className='wedContent'>
                        <h3>Danielle & Ronnie</h3>
                        <p>38 photos,hittery,Polland</p> 
                    </div>
                    
                </div>
                
            </div>
            <div className='viewMore'>
                <button type="submit">View more weddings -{`>`}</button>
                
            </div>
            
        </div>
    </div>
  )
}
export {RealWeding};
